import * as _ from './productbase.model';
import * as l from './linetype.model';
import * as u from './uom.model';
export class ProductModel extends _.ProductBaseModel
{
    prd_grp_code : string
    prd_grp_name: string
    uom_list: u.UOMModel[]
    must_sell: Boolean
    line_type: l.LineTypeModel
    line_type_list: l.LineTypeModel[] = [];
    item_cat_grp: string;
    base_uom: string;
    expiry_date: string; // CCLIORDER-3127
    isDisplayWarningExpiryDate: boolean = false;
    visa_no: string;
    contract_line_no: string;
    target_qty: number;
    used_qty: number;
    remain_qty: number;
    conv_factor: number;
    // EO-3457 - VN Display VISA and Batch
    batch_no: string;
    is_expiry_lt_6m: boolean = false;
}


// WEBPACK FOOTER //
// ./src/models/product/product.model.ts